// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectAlgorithmSubscribeMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { FieldsFactory } from '../../Factory/FieldsFactory';
import { MessageProcessorBase } from '../MessageProcessorBase';
export class AlgorithmSubscribeMessageProcessor extends MessageProcessorBase {
    decode(fs) {
        const msg = new DirectAlgorithmSubscribeMessage();
        const ff = FieldsFactory;
        msg.AlgorithmId = fs.GetValue(ff.FIELD_ALGORITHM_ID);
        msg.SubscribeAction = fs.GetValue(ff.FIELD_SUBSCRIPTION_ACTION);
        return [msg];
    }
}
